import { render } from "./mypage메인.vue?vue&type=template&id=28b43c2f"
import script from "./mypage메인.vue?vue&type=script&lang=js"
export * from "./mypage메인.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__